const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the infinite scroll
 */

app.directive('continuScroll', [function () {
  return {
    restrict: 'EA',
    scope: {
      continuScroll: '&',
      disableScroll: '=',
      reloadDistance: '@',
      permanantStop: '='
    },
    link: function (scope, element, attrs) {
      var container = element[0];
      var lastChild = null;
      var reloadDistance = parseInt(scope.reloadDistance);

      function scrollListen () {
        if (scope.disableScroll) {
          return;
        }
        if (container.scrollTop + container.offsetHeight >= container.scrollHeight - reloadDistance) {
          scope.continuScroll();
        }
      };

      var waiting;
      function onScroll () {
        if (waiting) {
          return;
        }
        waiting = true;
        scrollListen();
        setTimeout(function() {
          waiting = false;
        }, 150);
      };

      container.addEventListener('scroll', onScroll, false);

      scope.$watch('permanantStop', function(newValue) {
        if (newValue) {
          container.removeEventListener('scroll', onScroll, false);
        }
      });
    }
  };

}]);
